var _path, _circle, _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFailedIcon = function SvgFailedIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 105,
    viewBox: "0 0 139 105",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M126.239 85.9421H1.62889C1.36443 85.9358 1.10582 85.8631 0.876789 85.7307C0.647759 85.5983 0.455654 85.4105 0.318113 85.1846C0.180572 84.9586 0.102004 84.7017 0.0896216 84.4375C0.0772396 84.1733 0.13144 83.9101 0.247248 83.6723L27.8471 31.0385C28.3565 30.053 29.1229 29.2236 30.0652 28.6381C31.0074 28.0526 32.0905 27.7328 33.1997 27.7126C34.3088 27.6923 35.4028 27.9724 36.3658 28.5232C37.3288 29.0739 38.1249 29.8748 38.6699 30.8411L58.4076 65.2834L60.9735 65.6781C62.2526 64.4121 63.083 62.7628 63.3384 60.9813C63.5937 59.1998 63.26 57.3836 62.3881 55.8093L52.5192 38.3085L71.2371 3.27415C71.7571 2.29919 72.5288 1.48134 73.4719 0.905663C74.4151 0.329987 75.4952 0.0175049 76.6 0.000714263C77.7048 -0.0160764 78.794 0.263439 79.7542 0.810189C80.7144 1.35694 81.5106 2.15095 82.0599 3.10966L127.588 83.6394C127.72 83.8747 127.788 84.1405 127.786 84.4103C127.783 84.6801 127.71 84.9446 127.574 85.1774C127.438 85.4103 127.243 85.6034 127.009 85.7375C126.774 85.8717 126.509 85.9422 126.239 85.9421Z",
    fill: "#002E5C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 107.651,
    cy: 73.6039,
    r: 28.4201,
    fill: "#F1585E",
    stroke: "white",
    strokeWidth: 5.68402
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6155_9028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.7812 62.3972L117.219 83.8347",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7812 83.8347L117.219 62.3972",
    stroke: "white",
    strokeWidth: 4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6155_9028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.5,
    height: 24.5,
    fill: "white",
    transform: "translate(94.25 60.866)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFailedIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/FailedIcon.fe5100b8.svg";
export { ForwardRef as ReactComponent };